var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cuttable-product-preview" }, [
    _c("img", {
      staticClass: "cuttable-product-preview-image",
      style: _vm.imageProperties,
      attrs: { src: _vm.imageUrl, alt: _vm.imageAlt }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "cuttable-product-preview-crop",
      style: _vm.cropMaskStyle
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "cuttable-product-preview-crop-mask",
      style: _vm.topMaskStyle
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "cuttable-product-preview-crop-mask",
      style: _vm.bottomMaskStyle
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "cuttable-product-preview-crop-mask",
      style: _vm.leftMaskStyle
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "cuttable-product-preview-crop-mask",
      style: _vm.rightMaskStyle
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }